export default __webpack_public_path__ + "static/media/sa-dropdown.68d3ab51.webp";